import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SETTINGS } from '../configs/common.settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  constructor(private http: HttpClient, private router: Router) {}

  createInventory(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/inventory/create`, payload);
  }
  deleteInventory(id: string): Observable<any> {
    return this.http.delete(`${SETTINGS.BASE_API}/inventory/delete/${id}`);
  }
  getPagedInventories(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/inventory/get-paged`, payload);
  }
  updateInventory(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/inventory/update`, payload);
  }
  getOneInventoryId(inventoryId: any): Observable<any> {
    return this.http.get(
      `${SETTINGS.BASE_API}/inventory/get-one/${inventoryId}`
    );
  }
  getPagedJobsInventories(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/inventory/get-paged-by-client-id`,
      payload
    );
  }
}
